import React from "react";
import { Button } from "@mantine/core";
import { Title } from "../Title/Title";
import "./buttonRadioSelect.css";

type SelectedType = string | boolean;
type SelectedMultipleType = string[];
type SelectedIsMultipleType =
  | {
      isMultiple: true;
      value: SelectedMultipleType;
    }
  | {
      isMultiple: false;
      value: SelectedType;
    };
type OptionType = {
  label: string;
  value: SelectedIsMultipleType["value"];
  description?: string;
};

export interface ButtonRadioSelectProps {
  multiple?: SelectedIsMultipleType["isMultiple"];
  options: OptionType[];
  selected?: SelectedIsMultipleType["value"];
  setSelected: (value: SelectedType | SelectedMultipleType) => void;
  label: string;
  gridTemplateColumns?: string;
  position?: "center" | "left" | "right";
  dataTestId?: string;
}

export const ButtonRadioSelect: React.FC<ButtonRadioSelectProps> = ({
  options,
  selected,
  setSelected,
  label,
  multiple = false,
  gridTemplateColumns = "repeat(2, 1fr)",
  position = "center",
  dataTestId,
}) => {
  const classNameHandler = (option: OptionType) => {
    let className: string;
    if (multiple) {
      className = selected.toString().includes(option.value.toString())
        ? "selected"
        : "unselected";
    } else {
      className = selected === option.value ? "selected" : "unselected";
    }
    if (position) {
      className += ` button-${position}`;
    }
    return className;
  };

  const variantHandler = (option: OptionType) => {
    if (multiple) {
      return selected.toString().includes(option.value.toString())
        ? "outline"
        : "light";
    }
    return selected === option.value ? "outline" : "light";
  };

  return (
    <div style={{ width: "100%" }}>
      <Title title={label} size={5} mb="sm" />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: gridTemplateColumns,
          gap: "10px",
          width: "100%",
        }}
      >
        {options.map(option => (
          <Button
            style={
              option.description
                ? {
                    height: "auto",
                    padding: "15px",
                  }
                : {}
            }
            size="md"
            className={classNameHandler(option)}
            key={option.value.toString()}
            onClick={() => setSelected(option.value)}
            variant={variantHandler(option)}
            {...(dataTestId && {
              "data-testid": `${dataTestId}-${option.value}`,
            })}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflowWrap: "break-word",
                wordBreak: "break-word",
                whiteSpace: "normal",
                wordWrap: "break-word",
                overflow: "hidden",
                width: "100%",
              }}
            >
              {option.label}
              {option.description && (
                <>
                  <br />
                  <span
                    style={{
                      fontSize: "12px",
                      color: "gray",
                      marginTop: "7px",
                      fontWeight: "normal",
                    }}
                  >
                    {option.description}
                  </span>
                </>
              )}
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};
